export default __webpack_public_path__ + "media/new-graphic-design.jpg";